export default "__VITE_ASSET__f9f2f957__"